/**
 * @fileoverview > handler for the "/engagement/canvas_steps/:workflow_id/:app_group_id" endpoint
 * @note this is a POST request because we attach the steps ids to the payload in order
 *   to optimize the loading of steps due to the occassionally oversized nature of their
 *   message payloads
 * @todo this should be made a GET
 */

// eslint-disable-next-line you-dont-need-lodash-underscore/flatten

import type { CanvasStepDocument } from "@dashboardApi/apis/canvas/common";

// eslint-disable-next-line local-eslint-rules/no-ko-i18n-in-react
import { fetchStepData } from "@lib/canvas/fetchStepData/fetchStepData.ko";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { engagementCanvasStepsWorkflowIdAppGroupIdCacheKeys } from "./constants";
import type { PostEngagementCanvasStepsWorkflowIdAppGroupIdProps } from "./types";

/** a method to get the specified canvas steps for a given canvas. internally chunks out requests */
export const getCanvasStepsPost = reactQueryMutationAdapter(
  engagementCanvasStepsWorkflowIdAppGroupIdCacheKeys,
  (props: PostEngagementCanvasStepsWorkflowIdAppGroupIdProps): Promise<CanvasStepDocument[]> => {
    return fetchStepData(undefined, {
      workflowId: props.canvasId,
      appGroupId: props.appGroupId,
      stepIds: props.stepIds,
      viewActiveCanvas: props.viewActiveCanvas,
    });
  }
);
